<template>
  <div class="container">
    <header class="page-header">
      <ol class="breadcrumb page-breadcrumb">
        <li>
          <router-link :to="{ name: 'home'}">Home</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company', params: {id: productDetails.CompanyId}}">{{productDetails.CompanyName}}</router-link>
        </li>
        <li>
          <a href="#">{{productDetails.Name}}</a>
        </li>
      </ol>
    </header>
    <div class="row row-col-border" data-gutter="60">
      <div class="col-md-9">
        <div class="row">
          <div class="col-md-7">
            <div class="product-page-product-wrap jqzoom-stage">
              <div v-if="firstImage" class="clearfix">
                <a v-bind:href="firstImage" id="jqzoom" data-rel="gal-1">
                  <img v-bind:src="firstImage" alt="Image Alternative text" title="Image Title" />
                </a>
              </div>
            </div>
            <ul class="jqzoom-list">
              <li v-if="product.productImage" v-for="image in product.productImage">
                <a
                  v-bind:class="{ zoomThumbActive: image.IsDefault }"
                  href="javascript:void(0)"
                  v-bind:data-rel="buildImageRel(image)"
                >
                  <img v-bind:src="image.ImageURL" alt="Image Alternative text" title="Image Title" />
                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-5">
            <div class="_box-highlight">
              <h1>{{productDetails.Name}}</h1>
              <p class="product-page-pricetool-title">Category:</p>
              <p class="product-page-pricetool">{{productDetails.Category}}</p>
              <p class="product-page-desc-lg">{{productDetails.ShortDescription}}</p>

              <p class="product-page-desc">
                <router-link
                  target="_blank"
                  :to="{ name: 'company', params: { id: productDetails.CompanyId }}"
                >Company : {{productDetails.CompanyName}}</router-link>
              </p>
              <p class="product-page-desc">Location: {{productDetails.Location}}</p>
              <ul class="product-page-actions-list" v-if="getUser">
                <li>
                  <router-link :to="{ name: 'rfqProduct', params: { id: productDetails.Id }}" class="btn btn-lg btn-primary">Request Quotation</router-link>
                  <!--<a class="btn btn-lg btn-primary" href="#"><i class="fa fa-shopping-cart"></i>Request Quotation</a>-->
                </li>
                <li>
                  <!-- <a class="btn btn-lg btn-default" href="#">
                    <i class="fa fa-star"></i>Inquiry
                  </a> -->
                  <router-link :to="{ name: 'companyContactUs', params: { id: productDetails.CompanyId, tab: 4, subject: productDetails.Name }}" class="btn btn-lg btn-primary">Inquiry</router-link>
                </li>
              </ul>
              <ul class="product-page-actions-list" v-if="!getUser">
                <li>
                  <router-link :to="{ name: 'rfq'}" class="btn btn-lg btn-primary disabled">Request Quotation</router-link>
                </li>
                <li>
                   <a class="btn btn-lg btn-default disabled" href="#">
                    <i class="fa fa-star"></i>Inquiry
                  </a> 
                  
                </li>
              </ul>
               <p style="color:red" v-if="!getUser">Please <a style="color:blue" href="#nav-login-dialog" class="popup-text">login</a> before submitting RFQ or Inquiry</p>
            </div>
          </div>
        </div>
        <div class="gap"></div>
        <div class="tabbable product-tabs">
          <ul class="nav nav-tabs" id="myTab">
            <li class="active">
              <a href="#tab-1" data-toggle="tab">Description</a>
            </li>
            <li>
              <a href="#tab-2" data-toggle="tab">Company Profile</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane fade in active" id="tab-1">
              <table class="table">
                <tbody>
                  <tr>
                    <td>Product Name:</td>
                    <td>{{description.Name}}</td>
                  </tr>
                  <tr>
                    <td>SKU No:</td>
                    <td>{{description.SKUNo}}</td>
                  </tr>
                  <tr>
                    <td>Brand :</td>
                    <td>{{description.Brand}}</td>
                  </tr>
                  <tr>
                    <td>Model No:</td>
                    <td>{{description.ModelNo}}</td>
                  </tr>
                  <tr>
                    <td>Product Condition:</td>
                    <td>{{description.Condition}}</td>
                  </tr>
                  <tr>
                    <td>Material:</td>
                    <td>{{description.Material}}</td>
                  </tr>
                  <tr>
                    <td>Country Origin:</td>
                    <td>{{description.CountryOrigin}}</td>
                  </tr>
                </tbody>
              </table>
              <p></p>
              <table class="table">
                <tbody>
                  <tr>
                    <td>Description:</td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <span v-html="description.LongDescription"></span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane fade" id="tab-2">
              <table class="table">
                <tbody>
                  <tr>
                    <td>Company Name:</td>
                    <td>{{companyProfile.CompanyName}}</td>
                  </tr>
                  <tr>
                    <td>Date Incorporated:</td>
                    <td>{{companyProfile.DateIncorporated}}</td>
                  </tr>
                  <tr>
                    <td>Country Origin:</td>
                    <td>{{companyProfile.Country}}</td>
                  </tr>
                  <tr>
                    <td>Website URL :</td>
                    <td>
                      <a v-bind:href="companyProfile.WebsiteURL">{{companyProfile.WebsiteName}}</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane fade" id="tab-3">
              <article class="product-review">
                <!-- <div class="product-review-author">
                                    <img class="product-review-author-img" src="img/70x70.png" alt="Image Alternative text" title="Image Title" />
                </div>-->
                <div class="product-review-content-full">
                  <h5 class="product-review-title">Terrific Buy!</h5>
                  <ul class="product-page-product-rating">
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                  </ul>
                  <p class="product-review-meta">by Frank Mills on 08/14/2015</p>
                  <p
                    class="product-review-body"
                  >Rhoncus duis pellentesque quisque donec ligula rhoncus ante pharetra tincidunt velit orci cras condimentum varius</p>
                  <p class="text-success">
                    <strong>
                      <i class="fa fa-check"></i> I would recommend this to a friend!
                    </strong>
                  </p>
                  <ul class="list-inline product-review-actions">
                    <li>
                      <a href="#">
                        <i class="fa fa-flag"></i> Flag this review
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-comment"></i> Comment review
                      </a>
                    </li>
                  </ul>
                </div>
              </article>
              <article class="product-review">
                <!-- <div class="product-review-author">
                                    <img class="product-review-author-img" src="img/70x70.png" alt="Image Alternative text" title="Image Title" />
                </div>-->
                <div class="product-review-content-full">
                  <h5 class="product-review-title">Too Big. Unusable.</h5>
                  <ul class="product-page-product-rating">
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li>
                      <i class="fa fa-star"></i>
                    </li>
                    <li>
                      <i class="fa fa-star"></i>
                    </li>
                    <li>
                      <i class="fa fa-star"></i>
                    </li>
                  </ul>
                  <p class="product-review-meta">by Brandon Burgess on 08/14/2015</p>
                  <p
                    class="product-review-body"
                  >Potenti mollis ligula mollis aliquam lacinia pharetra fermentum nec vehicula parturient habitant facilisis platea consequat venenatis phasellus quam eu a placerat primis tellus sem rutrum posuere class</p>
                  <p class="text-danger">
                    <strong>
                      <i class="fa fa-close"></i> No, I would not recommend this to a friend.
                    </strong>
                  </p>
                  <ul class="list-inline product-review-actions">
                    <li>
                      <a href="#">
                        <i class="fa fa-flag"></i> Flag this review
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-comment"></i> Comment review
                      </a>
                    </li>
                  </ul>
                </div>
              </article>
              <article class="product-review">
                <!-- <div class="product-review-author">
                                    <img class="product-review-author-img" src="img/70x70.png" alt="Image Alternative text" title="Image Title" />
                </div>-->
                <div class="product-review-content-full">
                  <h5 class="product-review-title">Worth it</h5>
                  <ul class="product-page-product-rating">
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                    <li class="rated">
                      <i class="fa fa-star"></i>
                    </li>
                  </ul>
                  <p class="product-review-meta">by Frank Mills on 08/14/2015</p>
                  <p
                    class="product-review-body"
                  >Inceptos nostra ullamcorper faucibus commodo ad consequat aliquam nostra rhoncus laoreet lobortis ipsum</p>
                  <p class="text-success">
                    <strong>
                      <i class="fa fa-check"></i> I would recommend this to a friend!
                    </strong>
                  </p>
                  <ul class="list-inline product-review-actions">
                    <li>
                      <a href="#">
                        <i class="fa fa-flag"></i> Flag this review
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-comment"></i> Comment review
                      </a>
                    </li>
                  </ul>
                </div>
              </article>
            </div>
          </div>
        </div>
        <div class="gap"></div>
      </div>
      <LatestTendersRfq></LatestTendersRfq>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import LatestTendersRfq from "@/components/LatestTendersRfq";
import Vue from "vue";

// Vue.component("modal", {
//   template: "#modal-template"
// });

export default {
  components: {
    LatestTendersRfq
  },  
  created() {
    //console.log("MASUK CREATE ::::::::::::;;;;", this.$route.params.id);
    this.$store
      .dispatch("products/fetchProductDetails", {
        productId: this.$route.params.id
      })
      .then(() => {
        var evt = new CustomEvent("jqzoom-initialize", {});
        window.dispatchEvent(evt);
      });
  },
  computed: {
    ...mapState({
      product: state => state.products.productDetails
    }),
    firstImage() {
      var defaultImages = this.product.productImage.filter(
        image => image.IsDefault
      );
      if (defaultImages.length > 0) {
        return defaultImages[0].ImageURL;
      }

      if (this.product.productImage.length > 0) {
        return this.product.productImage[0].ImageURL;
      }

      return "";
    },
    description() {
      if (this.product.description.length > 0) {
        return this.product.description[0];
      }

      return {};
    },
    productDetails() {
      if (this.product.productDetail.length > 0) {
       // console.log('this.product.productDetail :::::::::::::: ', this.product.productDetail[0]);
        //console.log('this.product.productInfo :::::::::::::: ', this.productInfo);
        return this.product.productDetail[0];
      }
      return {};
    },    
    getUser() {
      //console.log('localStorage USER :::::::::: ', localStorage.getItem("user").id);
      return localStorage.getItem("user") !== null && localStorage.getItem("user") !== 'null' ? true : false;
    },
    companyProfile() {
      if (this.product.companyProfile.length > 0) {
        return this.product.companyProfile[0];
      }
      return {};
    },
    // productInfo() {
    //   let pInfo = {
    //       Id: this.productDetails.Id,
    //       CompanyName: this.productDetails.CompanyName,
    //       CompanyId: this.productDetails.CompanyId,
    //       CompanyLogo: this.companyProfile.LogoUrl,
    //       ProductImage: this.firstImage,
    //   };       
    //   return pInfo;
    // }

    
  },
  methods: {
    buildImageRel(image) {
      return (
        "{gallery:'gal-1', smallimage:'" +
        image.ImageURL +
        "', largeimage:'" +
        image.ImageURL +
        "'}"
      );
    },
    
  }
};
</script>
